import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { BUSINESS_TABS, isBusinessTab } from "./businessTabs";

export const BusinessBottomNavigation = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const tabParam = params.get("tab");
  const active = isBusinessTab(tabParam) ? tabParam : "listings";

  return (
    <nav className="mobile-bottom-nav md:hidden fixed left-3 right-3 z-50 rounded-full border border-border/80 bg-background/95 shadow-[0_10px_30px_-12px_hsl(var(--foreground)/0.28)] backdrop-blur-xl">
      <div className="flex h-[4.25rem] items-center justify-around px-2 py-2">
        {BUSINESS_TABS.map((t) => {
          const on = active === t.id;
          const Icon = t.icon;
          return (
            <Button
              key={t.id}
              variant="ghost"
              onClick={() => navigate(`/business?tab=${t.id}`)}
              aria-current={on ? "page" : undefined}
              className={`min-w-0 flex-1 flex-col items-center justify-center gap-1 rounded-full px-0 py-1 hover:bg-transparent active:scale-95 ${
                on ? "text-primary hover:text-primary" : "text-muted-foreground"
              }`}
            >
              <Icon className="h-6 w-6" strokeWidth={on ? 2.5 : 2} />
              <span className={`text-[10px] leading-none ${on ? "font-semibold" : "font-medium"}`}>{t.short}</span>
            </Button>
          );
        })}
      </div>
    </nav>
  );
};
